let usage = `
<Toggle v-model="value" label="A company"></Toggle>
`.slice(1);

export default {
  usage
};
